import { css } from "@emotion/react";

import { size } from "~/client/styles/emotion/mixins/size";
import tokens from "~/packages/design-tokens/dist/tokens";

/*
- `a:visited .ks`
- `a:hover .ks`
の詳細度が高いため!importantを使用している
https://github.com/bitjourney/kibela/blob/ee8954cf6e7d556b6bfb08c916dd30de5e7d671f/app/assets/stylesheets/utilities/mixin/_misc.scss#L55-L90
*/
export const iconCss = (iconSize: string) => {
  const { width, height } = size(iconSize);
  return css({
    fill: `${tokens.color.symbol.brand.default.value} !important`,
    width: `${width} !important`,
    height: `${height} !important`,
  });
};
